import moment from 'moment';

import {
    QUARTER_TO_DATE,
    YEAR_TO_DATE,
} from '../common/constants/definitions';

/* Returns number of days between start and end date
 *    - startDate: first date in selected range
 *    - endDate: last date in selected range
 *    - unit: 'days', 'months', etc. (see moment.js docs)
 */
export const getDifferenceInRange = ( startDate, endDate, unit = 'days' ) => {
    const formattedStart = moment( startDate, 'YYYY-MM-DD' );
    const formattedEnd = moment( endDate, 'YYYY-MM-DD' );

    return formattedEnd.diff( formattedStart, unit );
};

/* Subtracts additional interval from date range for YTD/QTD options so full data set can be displayed */
export const getAdjustedEndDate = ( option, interval, end ) => {
    let newEnd;
    if( option === YEAR_TO_DATE || option ===  QUARTER_TO_DATE ){
        newEnd = moment.utc().subtract( 1, interval ).format( 'YYYY-MM-DD' );
    }
    return newEnd ? newEnd : end;
};
